import { render, staticRenderFns } from "./TemplateRegistro.vue?vue&type=template&id=0eb4ef1e&scoped=true&functional=true&"
var script = {}
import style0 from "./TemplateRegistro.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TemplateRegistro.vue?vue&type=style&index=1&id=0eb4ef1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0eb4ef1e",
  null
  
)

export default component.exports